import { get_token } from "@/router";
import axios from "axios";
import { client_domain } from "@/main.js";

export default {
  data() {
    const data = {
      fab_position: {
        x: 0,
        y: 0
      },
      is_dragging: false,
      dragOffset: {
        x: 0,
        y: 0
      },
      fab_domain: false,
      default_fab_position: {
        x: window.innerWidth - 110,
        y: 450
      },
      is_minimized: false,
      current_corner: null,
      corner_threshold: 50,
      workbook_domain: false,
      visible_domain:false,
      apex_domain:false
    };

    return data;
  },
  mounted() {
    this.user_id = this.get_user_id();

    this.initialize_fab_position();
    this.setup_drag_listeners();
    if(client_domain.includes('engagenet')) {
      this.visible_domain = true;
    }
    if(client_domain.includes('apex')) {
      this.apex_domain = true;
    }


  },
  beforeUnmount() {
    this.remove_drag_listeners();
  },
  methods: {
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    //  launch_platform(platform) {
    //   alert("launching platform", platform);
    //   console.log('user_id', this.user_id);
    //   console.log('platform', platform);
    //     $.ajax({
    //       type: 'POST',
    //       url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/api/launch_platform/`,
    //       headers: {
    //         'Authorization': `Token ${get_token()}`,
    //         'Content-Type': 'application/json'
    //       },
    //       data: {
    //         platform: platform,
    //         external_user_id: this.user_id,
    //       },


    //       success: function(response) {
    //         console.log("response", response);
    //         if (response.redirect_url) {
    //           var $redirect_btn = $('#redirect_btn')
    //           $redirect_btn.attr('href', response.redirect_url);
    //           $redirect_btn[0].click();
    //         }
    //       },
    //       error: function(xhr) {
    //         if (xhr.status === 401) {
    //           window.location.href = "/sign_in_finale";
    //         }
    //       }
    //     });
    //   },

    is_aic_one_user() {
      return localStorage.getItem('aic_one_login') === 'true';
    },

    async launch_platform(platform) {
  const platform_url = `${process.env.VUE_APP_BACKEND_API_URL}/system_management/api/launch_platform/`;
  const headers = {
    'Authorization': `Token ${get_token()}`,
    'Content-Type': 'application/json',
  };
  const data = {
    platform,
    external_user_id: this.user_id,
  };

  try {
    const response = await axios.post(platform_url, data, { headers });

    if (response.data.redirect_url) {
      window.location.href = response.data.redirect_url;
    } else {
      console.warn("No redirect_url found in response");
    }
  } catch (error) {
    console.error("Failed to redirect to platform:", error.response || error);
  }
},


    initialize_fab_position() {
      var position_key = "position_key";
      var saved_data = localStorage.getItem(position_key);

      try {
        if (saved_data) {
          var data = JSON.parse(saved_data);

          if (
            data.position &&
            typeof data.position.x === 'number' &&
            typeof data.position.y === 'number'
          ) {
            this.fab_position = data.position;
            this.current_corner = data.corner;
            this.is_minimized = data.is_minimized || false;
          } else {
            this.fab_position = { ...this.default_fab_position };
          }

          if (this.current_corner) {
            this.$nextTick(() => {
              var $fabContainer = $(this.$refs.fab_container);
              $fabContainer.addClass(`fab-corner ${this.current_corner} fab-minimized`);
            });
          }
        } else {
          this.fab_position = { ...this.default_fab_position };
        }
      } catch (err) {
        this.fab_position = { ...this.default_fab_position };
      }
    },


    start_dragging(e) {
      if (!$(e.target).closest('#fabMain').length) return;

      this.is_dragging = true;
      var $fabContainer = $(this.$refs.fab_container);
      var rect = $fabContainer[0].getBoundingClientRect();


      if (e.type === 'mousedown') {
        this.dragOffset = {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        };
      } else if (e.type === 'touchstart') {
        this.dragOffset = {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top
        };
      }

      if (this.is_dragging) {
        $('.fab-option').css('pointer-events', 'none');
      }

      e.preventDefault();
    },

    during_dragging(e) {
      if (!this.is_dragging) return;

      let clientX, clientY;
      if (e.type === 'mousemove') {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.type === 'touchmove') {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      }

      var $fabContainer = $(this.$refs.fab_container);
      var fab_size = $fabContainer.width();
      var window_width = window.innerWidth;
      var window_height = window.innerHeight;

      var newX = Math.max(0, Math.min(window_width - fab_size, clientX - this.dragOffset.x));
      var newY = Math.max(0, Math.min(window_height - fab_size, clientY - this.dragOffset.y));

      var corner = this.check_corner_snap(clientX, clientY);

      if (corner) {
        this.if_corner(corner, $fabContainer, window_width, window_height, fab_size);
      }
      else {
        if (this.current_corner) {
          $fabContainer.removeClass(
            'fab-corner top-left top-right bottom-left bottom-right fab-minimized'
          );
          this.current_corner = null;
          this.is_minimized = false;
        }
        this.fab_position = { x: newX, y: newY };
      }
      e.preventDefault();
    },

    if_corner(corner, $fabContainer, window_width, window_height, fab_size) {

      this.current_corner = corner;
      $fabContainer
        .removeClass('top-left top-right bottom-left bottom-right')
        .addClass(`fab-corner ${corner} fab-minimized`);
      this.is_minimized = true;
      switch (corner) {
        case 'top-left':
          this.fab_position = { x: 0, y: 0 };
          break;
        case 'top-right':
          this.fab_position = { x: window_width - fab_size, y: 0 };
          break;
        case 'bottom-left':
          this.fab_position = { x: 0, y: window_height - fab_size };
          break;
        case 'bottom-right':
          this.fab_position = { x: window_width - fab_size, y: window_height - fab_size };
          break;
      }

    },

    stop_drag() {
      if (!this.is_dragging) return;
      this.is_dragging = false;
      $('.fab-option').css('pointer-events', 'auto');
      this.save_fab_position();
    },

    setup_drag_listeners() {

      var $fabMain = $('#fabMain');
      $fabMain.on('mousedown touchstart', this.start_dragging);

      $(window).on('mousemove touchmove', this.during_dragging);
      $(window).on('mouseup touchend', this.stop_drag);
      $(window).on('resize', this.handle_resize);
    },

    remove_drag_listeners() {
      $('#fabMain').off('mousedown touchstart', this.start_dragging);
      $(window).off('mousemove touchmove', this.during_dragging);
      $(window).off('mouseup touchend', this.stop_drag);
      $(window).off('resize', this.handle_resize);
    },

    handle_resize() {
      var fabSize = 56;
      var $window = $(window);
      this.fab_position.x = Math.max(0, Math.min($window.width() - fabSize, this.fab_position.x));
      this.fab_position.y = Math.max(0, Math.min($window.height() - fabSize, this.fab_position.y));

      localStorage.setItem("position_key", JSON.stringify(this.fab_position));
    },

    handle_fab_click() {
      if (this.is_minimized) {
        this.restore_fab();
      } else {
        this.toggle_fab_options();
      }
    },

    toggle_fab_options() {
      var fap_option = $('.fab-options');
      fap_option.toggleClass('show');
    },

    restore_fab() {
      this.is_minimized = false;
      this.current_corner = null;
      var $fabContainer = $(this.$refs.fab_container);
      $fabContainer.removeClass(
        'fab-corner top-left top-right bottom-left bottom-right fab-minimized'
      );

      var window_width = window.innerWidth;
      var window_height = window.innerHeight;
      var fab_size = $fabContainer.width();

      this.fab_position = {
        x: window_width - fab_size - 10,
        y: window_height - fab_size - 10
      };

      this.save_fab_position();
    },

    check_corner_snap(x, y) {
      var window_width = window.innerWidth;
      var window_height = window.innerHeight;
      var threshold = 0;
      var fab_size = $(this.$refs.fab_container).width();

      if (x <= threshold && y <= threshold) {
        return 'top-left';
      }
      if (x >= window_width - fab_size - threshold && y <= threshold) {
        return 'top-right';
      }
      if (x <= threshold && y >= window_height - fab_size - threshold) {
        return 'bottom-left';
      }
      if (x >= window_width - fab_size - threshold && y >= window_height - fab_size - threshold) {
        return 'bottom-right';
      }
      return null;
    },

    save_fab_position() {
      var position_data = {
        position: this.fab_position,
        corner: this.current_corner,
        is_minimized: this.is_minimized
      };

      localStorage.setItem("position_key", JSON.stringify(position_data));
    }
  }
}

